import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col } from 'react-bootstrap';
import config from 'react-global-configuration';
import axios from 'axios';

import toastr from "toastr";

import PropertyForm from './forms/propertyForm';
import FileForm from './forms/fileForm';

import fields from './forms/formsConfig'

import FormBuilder from '../../components/formBuilder/formBuilder'
import ListInfo from '../../components/listInfo';

const ModalCadastro = forwardRef(({ bindValues, onUpdate }, ref) => {

    const [activeTab, setActiveTab] = useState('');
    const [result, setResult] = useState({});
    const [attachments, setAttachments] = useState([]);
    const [formUpdateData, setFormUpdateData] = useState(null);
    const [indexListUpdate, setIndexListUpdate] = useState(null);
    const [formId, setFormId] = useState(null);
    const [listErrors, setListErrors] = useState([]);

    useEffect(() => {
        setActiveTab('');
        if (bindValues && Object.keys(bindValues).length > 0) {
            setResult(bindValues);
            setActiveTab('root');
        } else {
            setActiveTab('root');
        }
    }, [bindValues]);

    const handleTabSelect = (tab) => {
        setActiveTab(tab);
        setFormUpdateData(null);
        setIndexListUpdate(null);
    };

    const handleSubmit = async (values, id) => {

        let data = {};

        const prop = ['title', 'name', 'coords', 'kml', 'cnpj', 'elaw'];
        if (id === 'root' && id.indexOf(prop) === -1) {
            setResult((prevOptions) => ({
                ...prevOptions,
                ...values
            }));
        }
        else {
            const newValues = id !== 'dueDiligence' ? organizarPropriedades(values) : values;
            data = result;
            if (data.hasOwnProperty(id)) {
                if (indexListUpdate !== null) {
                    data[id][indexListUpdate] = newValues;
                } else {
                    data[id].push(newValues);
                }
            } else {
                data = { [id]: [newValues] };
            }
            setResult((prevOptions) => ({ ...prevOptions, ...data }));
            setFormUpdateData(null);
            setIndexListUpdate(null);
        }
        console.log(result)
    }

    const handleSetAttachments = (values, root = null) => {
        if (values) {
            let prevAttachments = attachments;
    
            if (root) {
                prevAttachments.splice(prevAttachments.findIndex((item) => item.name.toLowerCase().includes('.kml'.toLowerCase())), 1);
            }
    
            // if (prevAttachments.length > 0 && prevAttachments.some(item => item.name === values.name)) {
            //     return;
            // }
    
            setAttachments(() => ([...prevAttachments, values]));
            console.log(attachments);
        }
    }

    const handleDeleteListItem = (index, id) => {
        let data = result;
        let files = attachments
        if (data.hasOwnProperty(id)) {
            if (files && files.length > 0) {
                files.splice(files.findIndex((item) => item.name === data[id][index].file.name), 1);
            }
            data[id].splice(index, 1);
        }
        setResult((prevOptions) => ({ ...prevOptions, ...data }));
        setAttachments(files);
        setFormUpdateData(null);
        setIndexListUpdate(null);
        console.log(attachments);
    }

    const handleUpdateListItem = (index, id) => {
        if (id) {
            setFormId(id);
            if (result.hasOwnProperty(id)) {
                setIndexListUpdate(index);
                let data = result[id][index];
                Object.keys(result[id][index]).forEach((obj) => {
                    if (obj.toLowerCase().indexOf('date') !== -1 && result[id][index][obj] !== '') {
                        data[obj] = data[obj].split("/").reverse().join("-");
                    }
                })
                setFormUpdateData({ ...data });
            }
        }
    }

    useEffect(() => {
        if(formUpdateData && Object.keys(formUpdateData).length > 0){
            formUpdateData.title = formUpdateData.file?.title || '';
            formUpdateData.comments = formId && formId !== 'dueDiligence' ? formUpdateData.file?.comments || '' : formUpdateData.comments;
            formUpdateData.file = formUpdateData.file?.name || '';
            const text = document.querySelector('[name="submit"] > span').textContent.toString();
            document.querySelector('[name="submit"] > span').textContent = text.replace('Adicionar', 'Editar');
        } else {
            if (document.querySelector('[name="submit"] > span')) {
                const text = document.querySelector('[name="submit"] > span').textContent.toString();
                document.querySelector('[name="submit"] > span').textContent = text.replace('Editar', 'Adicionar');
            }
        }
      }, [formUpdateData]);

    const organizarPropriedades = (objeto) => {
        // Verifica se o objeto tem as propriedades necessárias
        if (objeto.hasOwnProperty('title') || objeto.hasOwnProperty('file') || objeto.hasOwnProperty('comments')) {
            // Cria um novo objeto para armazenar as propriedades aninhadas
            const propriedadesAninhadas = {
                title: objeto.title,
                name: objeto.file,
                comments: objeto.comments
            };

            Object.keys(propriedadesAninhadas).forEach((key) => {
                if (propriedadesAninhadas[key] == '')
                    delete propriedadesAninhadas[key]; // Remove as propriedades do objeto original
            })

            Object.keys(objeto).forEach((obj) => {
                if (obj.toLowerCase().indexOf('date') !== -1 && objeto[obj] !== '') {
                    objeto[obj] = objeto[obj].split("-").reverse().join("/");
                }
            })

            // Remove as propriedades do objeto original
            delete objeto.title;
            delete objeto.file;
            delete objeto.comments;
            delete objeto.fileChose;
            delete objeto.submit;

            // Adiciona o novo objeto aninhado à propriedade 'file' do objeto original
            if (Object.keys(propriedadesAninhadas).length > 0) {
                objeto.file = propriedadesAninhadas;
            }
        }

        return objeto;
    }
    
    useImperativeHandle(ref, () => ({
        handleSave: async () => {
            let data = result;
            const prop = !data.hasOwnProperty('elaw') ? ['title', 'name', 'coords', 'kml', 'cnpj'] : ['title', 'name', 'coords', 'kml', 'cnpj', 'elaw'];
            setListErrors([]);
            let countErr = [];
            prop.forEach(item => {
                if (!data.hasOwnProperty(item)) {
                    countErr.push(item.toString());                    
                } else {
                    if (data[item] === '') {
                        countErr.push(item.toString());
                    }
                }
            });
            setListErrors(countErr);
            if (countErr.length > 0) {
                toastr.error('Prencha os campos obrigatórios da aba "Dados Principais"');
            } else {
                try {
                    const url = config.get('urlbase') + (result.imovel_id  ? '/imoveis/update-imovel' : '/imoveis/create-imovel');
                    const userInfos = JSON.parse(localStorage.getItem('userInfos'));
                    const headers = { 'x-api-key': userInfos.data.Token, 'Content-Type': 'application/json' };
                    const params = {
                        customercnpj: userInfos.data.customercnpj,
                        contract_id: userInfos.data.contract_id,
                        imovel: result
                    };
                    if (result.imovel_id) {
                        params['imovel_id'] = result.imovel_id;
                    }
                    const response = (await axios.post(url, JSON.stringify(params), { headers: headers })).data.Item;
                    const imovelId = response.imovel_id;
                    const contractId = params.contract_id;
                    attachments.forEach(async (item) => {

                        const bucketS3 = config.get(item.type === 'application/pdf' ? 's3.bucketFiles' : 's3.bucketKML');
                        const uploadMode = item.type === 'application/pdf' ? 'uploadFiles' : 'uploadKml';

                        const urlUploadFile = `${config.get('urlbase')}/imoveis/upload-file?filename=${item.name}&imovel_id=${imovelId}&customercnpj=${params.customercnpj}&contract_id=${contractId}`;
                        console.log(urlUploadFile);
                        const blob = new Blob([item], { type: item.type === 'application/pdf' ? item.type : 'application/vnd.google-earth.kml+xml' });
                        const formData = new FormData();
                        formData.append('files', blob);
                        try {
                            const res = (await axios.get(urlUploadFile, {
                                headers: { 'x-api-key': userInfos.data.Token }
                            })).data.Item;
                            try {
                                let newUrl = res.Url
                                if (process.env.NODE_ENV !== 'production') {
                                    newUrl = newUrl.replace(`https://${bucketS3}.s3.amazonaws.com`, `${document.location.origin}/${uploadMode}`)
                                }
                                const response = await axios.put(newUrl, item, { headers: { 'x-api-key': userInfos.data.Token, 'Content-Type': item.type === 'application/pdf' ? item.type : 'application/vnd.google-earth.kml+xml', 'customercnpj': params.customercnpj, 'contract_id': contractId, 'imovel_id': imovelId, 'file_name': item.name } });
                                console.log(response);
                                console.log('File uploaded successfully');

                            } catch (error) {
                                toastr.error('Erro ao salvar o arquivo: ' + error.response.data.Erro);
                            }

                        } catch (error) {
                            toastr.error('Erro ao obter url de upload do arquivo: ' + error.response.data.Erro);
                        }
                        formData.delete('files');

                    })
                    handleTabSelect('root');
                    setResult({ contract_id: contractId });
                    setAttachments([]);
                    toastr.success('Dados salvos com sucesso');
                    onUpdate(imovelId);
                } catch (error) {
                    toastr.error('Erro realizar o cadastro');
                    console.error(error);
                }
            }
        }
    }));

    return (
        <Container fluid className='details-content'>
            <Nav variant="pills" className='mb-3' activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav.Item>
                    <Nav.Link eventKey="root">Dados Principais</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="licensingWaiver">Dispensa de Licenciamento</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="environmentalLicense">Licença Ambiental</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="noticeInfraction">Auto de Infração</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="tacAgency">TAC Órgão Ambiental</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="tacMp">TAC Ministério Público</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="otherAdministrativeProcesses">Outros Processos Administrativos</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="judicialProcess">Processo Judicial</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="car">CAR</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="dueDiligence">Due Diligence</Nav.Link>
                </Nav.Item>
            </Nav>

            <Row>
                {activeTab === 'root' &&
                    <>
                        <PropertyForm onSubmit={handleSubmit} onSubmitAttachment={handleSetAttachments} initialData={{...result}} errors={listErrors}></PropertyForm>
                        {/* <FormBuilder fields={fields.root} idForm={'root'} bindValues={result} onHandleChange={handleSubmit} submitForm={handleSubmit} title={'Preencha os dados da propriedade'} /> */}
                        {/* <FormBuilder fields={fields.ownership} idForm={'ownership'} onHandleChange={handleSubmit} submitForm={handleSubmit} title={''} />
                        <FormBuilder fields={fields.ownership2} idForm={'ownership'} onHandleChange={handleSubmit} submitForm={handleSubmit} title={''} /> */}
                        {/* {Object.entries(result).map(([key, value]) => (<p key={key}><strong>{key}</strong>: <>{value}</></p>))} */}
                    </>
                }
                {activeTab === 'licensingWaiver' && <><FormBuilder fields={fields.licensingWaiver} idForm={'licensingWaiver'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'Dispensa de Licenciamento'} bindValues={formUpdateData} /><ListInfo propertie={{ licensingWaiver: result.licensingWaiver }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'environmentalLicense' && <><FormBuilder fields={fields.environmentalLicense} idForm={'environmentalLicense'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'Licença Ambiental'} bindValues={formUpdateData} /><ListInfo propertie={{ environmentalLicense: result.environmentalLicense }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'noticeInfraction' && <><FormBuilder fields={fields.noticeInfraction} idForm={'noticeInfraction'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'Auto de Infração'} bindValues={formUpdateData} /><ListInfo propertie={{ noticeInfraction: result.noticeInfraction }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'tacAgency' && <><FormBuilder fields={fields.tacAgency} idForm={'tacAgency'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'TAC Órgão Ambiental'} bindValues={formUpdateData} /><ListInfo propertie={{ tacAgency: result.tacAgency }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'tacMp' && <><FormBuilder fields={fields.tacMp} idForm={'tacMp'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'TAC Ministério Público'} bindValues={formUpdateData} /><ListInfo propertie={{ tacMp: result.tacMp }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'otherAdministrativeProcesses' && <><FormBuilder fields={fields.otherAdministrativeProcesses} idForm={'otherAdministrativeProcesses'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'Outros Processos Administrativos'} bindValues={formUpdateData} /><ListInfo propertie={{ otherAdministrativeProcesses: result.otherAdministrativeProcesses }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'judicialProcess' && <><FormBuilder fields={fields.judicialProcess} idForm={'judicialProcess'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'Processo Judicial'} bindValues={formUpdateData} /><ListInfo propertie={{ judicialProcess: result.judicialProcess }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'car' && <><FormBuilder fields={fields.car} idForm={'car'} submitForm={handleSubmit} title={'CAR'} onfileChange={handleSetAttachments} bindValues={formUpdateData} /><ListInfo propertie={{ car: result.car }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
                {activeTab === 'dueDiligence' && <><FormBuilder fields={fields.dueDiligence} idForm={'dueDiligence'} submitForm={handleSubmit} onfileChange={handleSetAttachments} title={'Due Diligence'} bindValues={formUpdateData} /><ListInfo propertie={{ dueDiligence: result.dueDiligence }} onDelete={handleDeleteListItem} onUpdate={handleUpdateListItem}></ListInfo></>}
            </Row>
        </Container>
    );
});

export default ModalCadastro;